import Typography from "@/components/ui/typography";
import { cn } from "@/lib/utils";

import { Thread } from "../types/thread";
import { NewThreadButton } from "./NewThreadButton";
import { ThreadsList } from "./ThreadsList";

interface MobileChatHistoryProps {
  threads: Thread[];
  activeThreadId: string | null;
  onThreadSelect: (threadId: string) => void;
  onThreadDelete: (threadId: string) => void;
  onNewThread: () => void;
  isLoading?: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const MobileChatHistory = ({
  threads,
  activeThreadId,
  onThreadSelect,
  onThreadDelete,
  onNewThread,
  isLoading = false,
  open,
  onOpenChange,
}: MobileChatHistoryProps) => {
  const handleThreadSelect = (threadId: string) => {
    onThreadSelect(threadId);
    onOpenChange(false); // Close after selection
  };

  const handleNewThread = () => {
    onNewThread();
    onOpenChange(false); // Close after creating new thread
  };

  return (
    <div
      className={cn(
        "md:hidden fixed top-0 left-0 right-0 bottom-0 z-40 bg-background transition-opacity",
        open
          ? "animate-in fade-in opacity-100"
          : "animate-out fade-out opacity-0 pointer-events-none"
      )}
    >
      <div
        className={cn(
          "fixed left-0 right-0 bottom-0 top-16 bg-background text-foreground transition-transform flex flex-col overflow-y-auto",
          open
            ? "animate-in slide-in-from-top"
            : "animate-out slide-out-to-top"
        )}
      >
        {/* Header */}
        <div className="px-5 py-4 flex items-center justify-between">
          <Typography size="sh1" className="text-sds-text-black font-semibold">
            Chat history
          </Typography>
          <NewThreadButton onClick={handleNewThread} disabled={isLoading} />
        </div>

        {/* Threads List */}
        <div className="flex-1 overflow-hidden">
          <ThreadsList
            threads={threads}
            activeThreadId={activeThreadId}
            onThreadSelect={handleThreadSelect}
            onThreadDelete={onThreadDelete}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
